import { ws } from "../../../utils/common";
//import { isValidPassword, isValidEmail } from "../../../utils/validation";

export const eventTypeWS = async () => {
  const res = await ws(
    "GET",
    process.env.REACT_APP_ENDPOINT + "event-type/",
    null,
    false
  );

  if (res.error) {
    throw res.data;
  } else {
    return res.data;
  }
};

export const topicWS = async () => {
  const res = await ws(
    "GET",
    process.env.REACT_APP_ENDPOINT + "topic/",
    null,
    false
  );

  if (res.error) {
    throw res.data;
  } else {
    return res.data;
  }
};

export const associationsWS = async () => {
  const res = await ws(
    "GET",
    process.env.REACT_APP_ENDPOINT + "association/info/",
    null,
    null,
    false
  );

  if (res.error) {
    throw res.data;
  } else {
    return res.data;
  }
};

export const registrationWS = async ({
  name,
  surname,
  email,
  password,
  tel,
  birthDate,
  selectedEventType,
  language = "it",
  admin,
  activationCode,
  nameAssociation,
  description,
  address,
  dateOfFoundation,
  selectedAssociations,
  selectedAssociationTopic,
}) => {
  const body = {
    name,
    surname,
    email,
    password,
    tel,
    birth_date: birthDate,
    preferences: selectedEventType.toString(),
    language,
    admin,
    waiting_volunteer: admin ? "" : selectedAssociations.toString(),
  };

  if (admin)
    body.association = {
      code: activationCode,
      name: nameAssociation,
      description,
      address,
      date_of_foundation: dateOfFoundation,
      association_topic: selectedAssociationTopic.toString(),
    };

  const res = await ws(
    "POST",
    process.env.REACT_APP_ENDPOINT + "auth/registration",
    null,
    body,
    false
  );

  if (res.error) {
    throw res.data.message;
  } else {
    return res.data;
  }
};
